import React from 'react';
import Content from '../Content';

import { useAuth } from '../../AuthProvider';

const RunReports = () => {
  const { mongoUserId } = useAuth();

  if (!mongoUserId) return null;
  return <Content userId={mongoUserId} />;
};

export default RunReports;
